<template>
	<div class="app flex-row align-items-center">
		<div class="container">
			<div class="row justify-content-center">
				<div class="col-md-8">
					<div class="card-group mb-0">
						<div class="card p-4">
							<div v-if="!valid_register">
								<div class="card-body">
									<h1>Register</h1>
									<p class="text-muted">Register a new account</p>
									<p class="control has-icon has-icon-right">
										<input
											name="username"
											v-model="form_data.username"
											v-validate="'required|min:8'"

											:class="{'form-control': true, 'is-invalid': errors.has('username')}"
											type="text"
											placeholder="Username"
										/>
										<span v-show="errors.has('username')" class="help is-danger">
											{{ errors.first('username') }}
										</span>
									</p>
									<p class="control has-icon has-icon-right">
										<input
											name="email"
											v-model="form_data.user_email"
											v-validate="'required|email'"

											:class="{'form-control': true, 'is-invalid': errors.has('email')}"
											type="text"
											placeholder="Email"
										/>
										<span v-show="errors.has('email')" class="help is-danger">
											{{ errors.first('email') }}
										</span>
									</p>
									<p class="control has-icon has-icon-right">
										<input
											name="password"
											v-model="form_data.user_password"
											v-validate="'required|min:8'"

											:class="{'form-control': true, 'is-invalid': errors.has('password')}"
											type="password"
											placeholder="Password"
										/>
										<span v-show="errors.has('password')" class="help is-danger">
											{{ errors.first('password') }}
										</span>
									</p>
									<p class="control has-icon has-icon-right">
										<input
											name="re_password"
											v-validate="'required|confirmed:password'"

											:class="{'form-control': true, 'is-invalid': errors.has('re_password')}"
											type="password"
											placeholder="Retype the Password"
										/>
										<span v-show="errors.has('re_password')" class="help is-danger">
											{{ errors.first('re_password') }}
										</span>
									</p>
									<p class="control has-icon has-icon-right">
										<input
											name="name"
											v-model="form_data.user_fullname"
											v-validate="'required|min:8'"

											:class="{'form-control': true, 'is-invalid': errors.has('name')}"
											type="text"
											placeholder="Full Name"
										/>
										<span v-show="errors.has('name')" class="help is-danger">
											{{ errors.first('name') }}
										</span>
									</p>
									<div class="row">
										<div class="col-6">
											<button @click="register()" type="button" class="btn btn-primary px-4">
												Register
											</button>
										</div>
									</div>
								</div>
							</div>

							<div class="row">
								<div class="col-md-12" v-if="invalid_register">
									<div class="bg-danger text-center card">
										<div class="card-body">
											<blockquote class="card-blockquote"><p v-html="error_msg"></p></blockquote>
										</div>
									</div>
								</div>
								<div class="col-md-12" v-if="valid_register">
									<div class="bg-success text-center card">
										<div class="card-body">
											<blockquote class="card-blockquote">
												<p>Please check your email inbox for the verification mail.</p>
											</blockquote>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios'


export default {
	name: 'SocialRegister',
	data() {
		return {
			form_data: {
				user_email: '',
				user_password: '',
				username: '',
				user_fullname: '',
			},
			invalid_register: false,
			valid_register: false,
			error_msg: '',
		}
	},
	methods: {
		register() {
			this.invalid_register = false
			this.valid_register = false
			this.$validator.validateAll().then((result) => {
				if (result) {
					var data = this.form_data

					data.user_token = this.$route.params.token

					// valid form
					axios
						.post('/user/social_register', data)
						.then((response) => {
							var record = response.data
							if (record.status == 0) {
								this.invalid_register = true
								this.error_msg = record.msg
							} else {
								this.valid_register = true
								// setTimeout(()=> {
								//     this.$router.push('/user/login', () => {
								//         this.$root.$emit('showVerificationBlock');
								//     });
								// }, 3500);
							}
						})
						.catch((e) => {
							this.invalid_register = true
							this.error_msg = 'Error Access Token'
						})
				} else {
					// invalid
				}
			})
		},
	},
    created() {
        this.$root.loader = !true
    }
}
</script>
